import React, { useContext, useEffect, useRef, useState } from 'react'
import { Formik, Form, Field } from 'formik';
import Layout from '../Layouts/Layout'
import { getImages } from '../Const'
import PdfDownloader from './PdfDownloader';
import html2pdf from 'html2pdf.js';
import ListFormField from './ListFormField';
import ModalLayoutNew from '../Modals/ModalLayoutNew';
import EmailBuilderModal from './EmailBuilderModal';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { LeadsContext } from '../Context/LeadsContext';
import { useLocation, useParams } from 'react-router-dom';
import PrintBuilder from './PrintBuilder';
import DownloadBuilder from './DownloadBuilder';

const AppraisalBuilder = () => {
    const location = useLocation();
    const [selectedID, setSelectedID] = useState(null); // State for id
    const { filteredLeads, numberFormatter, emailScripts, leadFields, sendPlainTextEmail, updateLeadDataMultiple, addNote, updateNote } = useContext(LeadsContext);

    const formikRef = useRef();

    const pdfRef = useRef(null);
    const downloadRef = useRef(null);
    const printRef = useRef(null);
    const [openEditModal, setOpenEditModal] = useState(null);
    const handleEditText = (fieldName) => {
        setOpenEditModal(fieldName)
    }
    const handleCloseBtn = () => {
        setOpenEditModal(false)
    }
    const textareaText = "";
    // Print and Download
    const [generatePdf, setGeneratePdf] = useState(false);
    const handleDownloadPDF = async () => {
        setGeneratePdf(true);
        const element = downloadRef.current;
        try {
            const options = {
                margin: 0,
                filename: "file.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    windowWidth: 380,   // force snapshot width
                    windowHeight: 620,  // force snapshot height
                },
                jsPDF: {
                    unit: "pt",
                    format: [380, 620],   // 👈 white background PDF size
                    orientation: "portrait"
                },
                pagebreak: { mode: ["avoid-all"] } // prevent auto-splitting
            };

            await html2pdf()
                .set(options)
                .from(element)
                .save();

        } catch (error) {
            console.error("PDF generation failed", error);
        } finally {
            setGeneratePdf(false);
        }
    };

    const handlePrint = () => {
        const printContent = printRef.current.innerHTML;
        const printWindow = window.open('', '', 'width=507,height=540');
        printWindow.document.write(`
        <html>
        <head>
            <title>Print</title>
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap" rel="stylesheet" />
            <style>
            html, body {
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
                background: white;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
            }
            body {
                -webkit-transform: scale(1);
                transform: scale(1);
            }
            .print-container {
                box-sizing: border-box;
                margin: 0 auto;
                zoom: 1;
                background: white;
            }

            p {
                margin: 0 !important;
                padding: 0 !important;
                line-height: 15px !important;
            }
            @page {
                margin: 0;
            }

            @media print {
                html, body {
                    margin: 0;
                    padding: 0;
                    overflow: visible !important;
                }

                body {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
                .print-container {
                    margin: 0 auto;
                    page-break-inside: avoid;
                }
            }
            </style>
        </head>
        <body>
            <div class="print-container">
            ${printContent}
            </div>
        </body>
        </html>
        `);

        printWindow.document.close();
        printWindow.onload = () => {
            printWindow.document.fonts.ready.then(() => {
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 300);
            });
        };
    };


    const [visibleBox, setVisibleBox] = useState(null);
    const handleDefineStyle = (fieldName) => {
        setVisibleBox(visibleBox === fieldName ? null : fieldName);
    };
    const closeDefineStyle = () => {
        setVisibleBox(null)
    }
    const [fontSize, setFontSize] = useState('');
    const [color, setColor] = useState('#666666');
    const setFieldStyle = (fieldName, newStyle) => {
        initialValues[fieldName] = { ...initialValues[fieldName], ...newStyle };
    };
    // Email Send
    const [openEmailModal, setOpenEmailModal] = useState(false);
    const handleEmailBtn = () => {
        setOpenEmailModal(true)
    }
    const closeEmailBtn = () => {
        setOpenEmailModal(false)
    }
    const [generateText, setGenerateText] = useState(false);
    const [pdfFileName, setPdfFileName] = useState("Appraisal_Offer.pdf");
    const fetchPdf = async () => {
        const element = downloadRef.current;
        setGenerateText(true);
        const options = {
            margin: 0,
            filename: pdfFileName, // Set the file name here
            image: { type: "jpeg", quality: 1 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                windowWidth: 400,   // force snapshot width
                windowHeight: 620,  // force snapshot height
            },
            jsPDF: {
                unit: "pt",
                format: [400, 620],   // 👈 white background PDF size
                orientation: "portrait"
            },
        };

        const pdfFile = await html2pdf()
            .set(options)
            .from(element)
            .outputPdf("datauristring") // Generate the PDF as a Base64 string
            .catch((error) => {
                console.error("PDF generation failed:", error);
            });

        setGenerateText(false);

        return pdfFile;
    };

    // Data update according to Appraisal details action

    /*const allData = [
      ...commonCqData,
      ...leadsBoyntonBeach,
      ...leadsPompanoBeach
    ];*/

    const [initialValues, setInitialValues] = useState({
        full_name: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        first_name: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        last_name: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        agent_first_name: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        email: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: color || '#666666',
        },
        agent_email: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: color || '#666666',
        },
        phone: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        appraisal_date: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        address: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        expiration_date: {
            enabled: true,
            value: '',
            fontSize: '16',
            color: '#10758d',
        },
        appraisal: {
            enabled: true,
            value: '',
            fontSize: '33',
            color: '#666666',
        },
        year: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        make: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        model: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        vin: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        mileage: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        vehicle_condition: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        promoBanner: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#999999',
        },
        locations: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#999999',
        },
        appraisal_note: {
            enabled: true,
            value: textareaText,
        },
    });

    const [matchedData, setMatchedData] = useState(selectedID ? filteredLeads.find((item) => String(item.id) === selectedID) : null);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get("lead_id");
        setSelectedID(id);

        console.log("matchedData", matchedData);
        console.log("InitialValues", initialValues);

        var found_lead = selectedID ? filteredLeads.find((item) => String(item.id) === selectedID) : null;

        setMatchedData(found_lead);

        if (queryParams.has("email")) setOpenEmailModal(true);


    }, [filteredLeads.length, location.search]);
    useEffect(() => {
        console.log("update", matchedData);
        const updatedData = matchedData;

        const appraisalNote = updatedData?.notes.findLast((note) => note.title == "Appraisal Details");

        setInitialValues(prevValues => ({
            ...prevValues,
            full_name: {
                enabled: true,
                value: updatedData?.full_name || prevValues.full_name.value,
                fontSize: '' || '12',
                color: '' || '#666666',
                editable: true
            },
            first_name: {
                enabled: true,
                value: updatedData?.first_name || prevValues.first_name.value,
                fontSize: '' || '12',
                color: '' || '#666666',
            },
            last_name: {
                enabled: true,
                value: updatedData?.last_name || prevValues.last_name.value,
                fontSize: '' || '12',
                color: '' || '#666666',
            },
            agent_first_name: {
                enabled: true,
                value: updatedData?.agent_first_name || prevValues.agent_first_name.value,
                fontSize: '' || '12',
                color: '' || '#666666',
            },
            email: {
                enabled: true,
                value: updatedData?.email || prevValues.email.value,
                fontSize: '12',
                color: color || '#666666',
                editable: true
            },
            agent_email: {
                enabled: true,
                value: updatedData?.agent_email || prevValues.agent_email.value,
                fontSize: '12',
                color: color || '#666666',
            },
            phone: {
                enabled: true,
                value: updatedData?.phone || prevValues.phone.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            appraisal_date: {
                enabled: true,
                value: updatedData?.created_at_str || prevValues.appraisal_date.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            address: {
                enabled: true,
                value: (updatedData?.full_address) || prevValues.address.value,
                fontSize: '12',
                color: '#666666',
            },
            expiration_date: {
                enabled: true,
                value: updatedData?.expiration_str || prevValues.expiration_date.value,
                fontSize: '16',
                color: '#10758d',
                editable: true
            },
            appraisal: {
                enabled: true,
                value: numberFormatter(updatedData?.appraisal || prevValues.appraisal.value, true),
                fontSize: '33',
                color: '#666666',
                editable: true
            },
            year: {
                enabled: true,
                value: updatedData?.year || prevValues.year.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            make: {
                enabled: true,
                value: updatedData?.make || prevValues.make.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            model: {
                enabled: true,
                value: updatedData?.model || prevValues.model.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            vin: {
                enabled: true,
                value: updatedData?.vin || prevValues.vin.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            mileage: {
                enabled: true,
                value: numberFormatter(updatedData?.mileage || prevValues.mileage.value),
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            vehicle_condition: {
                enabled: true,
                value: updatedData?.vehicle_condition || prevValues.vehicle_condition.value,
                fontSize: '12',
                color: '#666666',
                editable: true
            },
            promoBanner: {
                enabled: true,
                value: prevValues.promoBanner.value,
                fontSize: '12',
                color: '#999999',
            },
            locations: {
                enabled: true,
                value: updatedData?.location || prevValues.locations.value,
                fontSize: '12',
                color: '#999999',
            },
            appraisal_note: {
                enabled: true,
                note_id: appraisalNote?.id,
                value: appraisalNote?.note || prevValues.appraisal_note.value
            },
        }));
    }, [matchedData]);

    return (
        <>
            <Layout hideTopBar={true}>
                <section className='main-block py-4' style={{ borderTop: 'solid 1px #000' }}>
                    <div className='container-fluid'>
                        <div className='d-flex align-items-center justify-content-between mb-3'>
                            <div className='lg-title text-uppercase font-26'>Appraisal Builder</div>
                            <div>
                                {generateText ?
                                    <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3'>
                                        Generating...
                                    </button>
                                    : <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3' onClick={() => setOpenEmailModal(true)}>
                                        <span className='apl-email-icon'></span> Email
                                    </button>
                                }
                                {generatePdf ?
                                    <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3'>
                                        Generating...
                                    </button> :
                                    <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3' onClick={handleDownloadPDF}>
                                        <span className='apl-download-icon'></span> Download
                                    </button>
                                }
                                <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2' onClick={handlePrint}>
                                    <span className='apl-print-icon'></span> Print
                                </button>
                            </div>
                        </div>

                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            innerRef={formikRef}
                            onSubmit={(values) => {

                                const update_values = Object.keys(values).filter((i) => values[i].editable).reduce((res, key) => (res[key] = values[key].value, res), {});
                                console.log(values, update_values);

                                update_values.id = matchedData.id;
                                update_values.lead_type = matchedData.lead_type;
                                update_values.appraisal_stage = matchedData.appraisal_stage;

                                update_values.appraisal = parseInt((update_values.appraisal + "").replace(/\D/g, ""));
                                update_values.year = parseInt((update_values.year + "").replace(/\D/g, ""));
                                update_values.mileage = parseInt((update_values.mileage + "").replace(/\D/g, ""));

                                var dateObj = new Date(update_values.appraisal_date);
                                console.log(update_values.appraisal_date, dateObj);
                                update_values.appraisal_date = dateObj.toISOString();

                                dateObj = new Date(update_values.expiration_date);
                                update_values.expiration_date = dateObj.toISOString();

                                console.log(update_values);

                                updateLeadDataMultiple(update_values);


                                if (values.appraisal_note.note_id) updateNote({ 'id': values.appraisal_note.note_id, 'note': values.appraisal_note.value });
                                else addNote({ 'id': matchedData.id, 'title': 'Appraisal Details', 'subtitle': '', 'note': values.appraisal_note.value });
                            }}
                        >
                            {({ values, setFieldValue }) => (
                                <Form className=''>
                                    <div className='gray-box ab-flex d-flex p-0'>
                                        <div className='ab-left'>
                                            <div className='ab-box'>
                                                <div className='ab-header'>CUstomer Info</div>
                                                <div className='ab-body'>
                                                    <ul className='ab-list'>
                                                        <ListFormField
                                                            fieldName="full_name"
                                                            textLabel='Full Name'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={31}
                                                        />
                                                        <ListFormField
                                                            fieldName="email"
                                                            textLabel='Email'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={29}
                                                        />
                                                        <ListFormField
                                                            fieldName="phone"
                                                            textLabel='Phone'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={18}
                                                        />
                                                        <ListFormField
                                                            fieldName="appraisal_date"
                                                            textLabel='Date of Appraisal'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={12}
                                                        />
                                                        {/* <ListFormField
                                                            fieldName="address"
                                                            textLabel='Address'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        /> */}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='ab-box'>
                                                <div className='ab-header'>Appraisal Details</div>
                                                <div className='ab-body'>
                                                    <ul className='ab-list'>
                                                        <ListFormField
                                                            fieldName="expiration_date"
                                                            textLabel='Offer Valid Date'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={10}
                                                        />
                                                        <ListFormField
                                                            fieldName="appraisal"
                                                            textLabel='Appraisal Value'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={10}
                                                        />
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='ab-box'>
                                                <div className='ab-header'>Vehicle Info</div>
                                                <div className='ab-body'>
                                                    <ul className='ab-list'>
                                                        <ListFormField
                                                            fieldName="year"
                                                            textLabel='Year'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={12}
                                                        />
                                                        <ListFormField
                                                            fieldName="make"
                                                            textLabel='Make'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={22}
                                                        />
                                                        <ListFormField
                                                            fieldName="model"
                                                            textLabel='Model'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={25}
                                                        />
                                                        <ListFormField
                                                            fieldName="vin"
                                                            textLabel='VIN'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={25}
                                                        />
                                                        <ListFormField
                                                            fieldName="mileage"
                                                            textLabel='Miles'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            maxLength={15}
                                                        />
                                                        {/* <ListFormField
                                                            fieldName="vehicle_condition"
                                                            textLabel='Vehicle Condition'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        /> */}
                                                        <li>
                                                            <div className='d-flex align-items-center'>
                                                                <div>
                                                                    <label className="custom-checkbox ab-checkbox">
                                                                        <Field
                                                                            type="checkbox"
                                                                            name="vehicle_condition.enabled"
                                                                            id="vehicle_condition"
                                                                        />
                                                                        <label htmlFor="vehicle_condition">Vehicle Condition</label>
                                                                    </label>
                                                                </div>
                                                                <div className='mx-auto position-relative'>
                                                                    <button type='button' className='ab-edit-btn' onClick={() => handleEditText("vehicle_condition")}><img src={getImages('edit_pencil.svg')} /> Edit</button>
                                                                    <div className={`edit-box ${openEditModal === "vehicle_condition" ? "open" : ""}`}>
                                                                        <div className="d-flex align-items-center justify-content-between ee-title-flex">
                                                                            <div className="ee-title text-uppercase">Edit Text</div>
                                                                            <div>
                                                                                <button type="button" className="ee-close" onClick={handleCloseBtn}>
                                                                                    <img src={getImages('ee-close.svg')} alt="Close" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="ee-body">
                                                                            <div>
                                                                                {/*<ReactQuill
                                                                                    value={values.vehicle_condition?.value.replace(/\n/g, '<br />')} // Bind to Formik's state
                                                                                    //  onChange={(value) =>
                                                                                    //    setFieldValue('vehicle_condition.value', value) // Update Formik's state
                                                                                    //  }
                                                                                    onChange={(value) =>
                                                                                        setFieldValue('vehicle_condition', {
                                                                                            ...values.vehicle_condition,
                                                                                            value,
                                                                                        })
                                                                                    }
                                                                                    className="w-100 mb-3"
                                                                                />*/}
                                                                                <textarea className="editnote-textarea" value={values.vehicle_condition?.value}
                                                                                    onChange={(e) => {
                                                                                        console.log(e.target.value);
                                                                                        setFieldValue('vehicle_condition', {
                                                                                            ...values.vehicle_condition,
                                                                                            ["value"]: e.target.value,
                                                                                        })
                                                                                    }
                                                                                    }
                                                                                >
                                                                                </textarea>
                                                                                <div className="text-end">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={handleCloseBtn}
                                                                                        className="blue-btn w-180"
                                                                                    >
                                                                                        Save
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className='d-flex align-items-center'>
                                                                <div>
                                                                    <label className="custom-checkbox ab-checkbox">
                                                                        <Field
                                                                            type="checkbox"
                                                                            name="appraisal_note.enabled"
                                                                            id="appraisal_note"
                                                                        />
                                                                        <label htmlFor="appraisal_note">Appraisal Details</label>
                                                                    </label>
                                                                </div>
                                                                <div className='mx-auto position-relative'>
                                                                    <button type='button' className='ab-edit-btn' onClick={() => handleEditText("appraisal_note")}><img src={getImages('edit_pencil.svg')} /> Edit</button>
                                                                    <div className={`edit-box ${openEditModal === "appraisal_note" ? "open" : ""}`}>
                                                                        <div className="d-flex align-items-center justify-content-between ee-title-flex">
                                                                            <div className="ee-title text-uppercase">Edit Text</div>
                                                                            <div>
                                                                                <button type="button" className="ee-close" onClick={handleCloseBtn}>
                                                                                    <img src={getImages('ee-close.svg')} alt="Close" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="ee-body">
                                                                            <div>
                                                                                {/*<ReactQuill
                                                                                    value={values.appraisal_note?.value.replace(/\n/g, '<br />')} // Bind to Formik's state
                                                                                    //  onChange={(value) =>
                                                                                    //    setFieldValue('appraisal_note.value', value) // Update Formik's state
                                                                                    //  }
                                                                                    onChange={(value) =>
                                                                                        setFieldValue('appraisal_note', {
                                                                                            ...values.appraisal_note,
                                                                                            value,
                                                                                        })
                                                                                    }
                                                                                    className="w-100 mb-3"
                                                                                />*/}
                                                                                <textarea className="editnote-textarea" value={values.appraisal_note?.value}
                                                                                    onChange={(e) => {
                                                                                        console.log(e.target.value);
                                                                                        setFieldValue('appraisal_note', {
                                                                                            ...values.appraisal_note,
                                                                                            ["value"]: e.target.value,
                                                                                        })
                                                                                    }
                                                                                    }
                                                                                >
                                                                                </textarea>
                                                                                <div className="text-end">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={handleCloseBtn}
                                                                                        className="blue-btn w-180"
                                                                                    >
                                                                                        Save
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='ab-box'>
                                                <div className='ab-header'>Additional Includes</div>
                                                <div className='ab-body'>
                                                    <ul className='ab-list'>
                                                        <ListFormField
                                                            fieldName="promoBanner"
                                                            textLabel='Promo Banner'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            hideInputField="true"
                                                        />
                                                        <ListFormField
                                                            fieldName="locations"
                                                            textLabel='Locations'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                            hideInputField="true"
                                                        />
                                                        <li className='py-4 px-3 text-center'>
                                                            <button type='submit' className='blue-btn apply-change-btn'>APPLY CHANGES</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='ab-right'>
                                            <div ref={pdfRef}>
                                                <div
                                                    style={{
                                                        padding: "15px 25px 30px",
                                                        backgroundColor: "#fff",
                                                        fontFamily: "Arial",
                                                        width: "380pt",
                                                        height: "auto",
                                                        transform: "scale(2.04)",
                                                        transformOrigin: "top left",
                                                    }}
                                                >
                                                    <DownloadBuilder
                                                        pdfRef={pdfRef}
                                                        values={values}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ display: "none", }}>
                                                <div ref={downloadRef}>
                                                    <div
                                                        style={{
                                                            padding: "15px 25px 30px",
                                                            backgroundColor: "#fff",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "380pt",
                                                            height: "auto",
                                                            margin: "0 auto",
                                                            lineHeight: "normal",
                                                        }}
                                                    >
                                                        <DownloadBuilder
                                                            values={values}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ display: "none", }}>
                                                <PrintBuilder
                                                    printRef={printRef}
                                                    values={values}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </section>
            </Layout>
            <ModalLayoutNew open={openEmailModal} close={closeEmailBtn} modalWidth={650}>
                <EmailBuilderModal
                    close={closeEmailBtn}
                    pdfFileName={pdfFileName}
                    emailScripts={emailScripts}
                    leadData={matchedData}
                    leadFields={leadFields}
                    sendPlainTextEmail={sendPlainTextEmail}
                    fetchPdf={fetchPdf}
                />
            </ModalLayoutNew>
        </>
    )
}

export default AppraisalBuilder